import { IEmpresas } from "../interfaces/IEmpresas";
import { IEsteira } from "../interfaces/IEsteira";
import api from './Api';

class EmpresasService {
    async obterTodos(): Promise<IEmpresas[]> {
        const { data: result } = await api.get<IEmpresas[]>('Empresa');
        
        return result;
    }

    async obterTodosPorClienteID(clienteID: number): Promise<IEmpresas[]> {
        const { data: result } = await api.get<IEmpresas[]>('Empresa/BuscarPorClienteID/'+clienteID);
        
        return result;
    }

    async obterPorId(empresaID: number): Promise<IEmpresas> {
        const { data: result } = await api.get<IEmpresas>(`Empresa/${empresaID}`);

        return result;
    }

    async criar(empresa: IEmpresas): Promise<IEmpresas> {
        const { data: result } = await api.post('Empresa', empresa);

        return result;
    }

    async atualizar(empresa: IEmpresas): Promise<IEmpresas> {
        const { data: result } = await api.put(`Empresa/${empresa.id}`, empresa);

        return result;
    }

    async excluir(empresaID: number): Promise<void> {
        const { data: result } = await api.delete(`Empresa/${empresaID}`);

        return result;
    }

    async obterTodosPorUsuarioId(usuarioID: number): Promise<IEmpresas[]> {
        const { data: result } = await api.get<IEmpresas[]>('Empresa/BuscarPorUsuarioID/'+usuarioID);
        
        return result;
    }

    async obterEsteiras(empresaID: number): Promise<IEsteira[]>  {
        const { data: result } = await api.get<IEsteira[]>('Esteira/ListarPorEmpresa/'+empresaID);
        return result;
    }
}


export default new EmpresasService();